var React = require('react');

function SignupArrowIconLong (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M146.495 6.49497C146.768 6.22161 146.768 5.77839 146.495 5.50503L142.04 1.05025C141.767 0.776886 141.324 0.776886 141.05 1.05025C140.777 1.32362 140.777 1.76684 141.05 2.0402L145.01 6L141.05 9.9598C140.777 10.2332 140.777 10.6764 141.05 10.9497C141.324 11.2231 141.767 11.2231 142.04 10.9497L146.495 6.49497ZM146 5.3L0 5.3V6.7L146 6.7V5.3Z","fill":"#FEFEFE"}));
}

SignupArrowIconLong.defaultProps = {"width":"147","height":"12","viewBox":"0 0 147 12","fill":"none"};

module.exports = SignupArrowIconLong;

SignupArrowIconLong.default = SignupArrowIconLong;
